import { Component, OnInit } from '@angular/core';
import { InternalService } from '../../services/internal.service';
import { BillingService } from '../../services/billing.service';
import { NotifierService } from '../../../system/shared/notifier/notifier.service';
import { CxcService } from '../../services/cxc.service';
import { ClientBusinessNameService } from '../../services/client-business-name.service';
import { ListofvaluesService } from '../../services/listofvalues.service';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-bill-specific',
  templateUrl: `bill-specific.component.html`,
  styleUrls: ['bill-specific.component.scss'],
  providers: [CxcService, BillingService, ClientBusinessNameService, ListofvaluesService]
})
export class BillSpecificComponent implements OnInit {
  billingData: any = {};
  budgetHeaderData: any = {};
  showPopup = false;
  originalClientData: IBusiness = {};
  businessNameData: IBusiness = {};
  businessNameList: Array<IBusiness> = [];
  detraction_account: string = '';
  bill_building: boolean = false;
  factura_id: any ;
  constructor(private internalService: InternalService,
    private cxcpaymentService: CxcService,
    private billingService: BillingService,
    private notifierService: NotifierService,
    private listofvaluesService: ListofvaluesService,
    private routes: Router,
    private clientBusinessService: ClientBusinessNameService) {
    this.internalService.internalListener.subscribe(
      (result: any) => {
        if (result.pronosBill && result.budgetHeader && result.show) {
          this.billingData = result.pronosBill;
          this.budgetHeaderData = result.budgetHeader;
          this.showPopup = result.show;
          this.originalClientData = {
            address: this.billingData.client_address,
            email: this.billingData.client_email,
            id_client: this.billingData.id_client,
            name: this.billingData.clientData.companyName,
            doc_num: this.billingData.clientData.doc_num,
            doc_type: this.billingData.clientData.doc_type
          };
          this.businessNameData = this.originalClientData;
          this.clientBusinessService.getAllBusiness(this.billingData.id_client).subscribe((resultListBusinessNames: Array<IBusiness>) => {
            this.businessNameList = resultListBusinessNames;
          });
          console.log(this.billingData.discounts)
        }else{
          this.billingData.tipo_de_cambio = '';

        }
      });
    this.listofvaluesService.getLdvByCode('TBWA-OBSERVATION-BILLING').subscribe((result: any) => {
      this.detraction_account = result[0].value;
    });
  }

  ngOnInit() {

  }

  createBill() {
    this.bill_building = true;
    if (this.billingData.fechaVencimiento && this.billingData.condicionesPago) {
      this.notifierService.systemNotify({
        title: 'Espere',
        message: 'Generando Factura',
        type: 'info',
        duration: 20000
      });
      var objClientData;
      switch( this.businessNameData.doc_type){
        case 'RUC':
          objClientData = {
        
            id: this.businessNameData.id_client,
            companyName: this.businessNameData.name,
            direction: this.businessNameData.address,
            doc_num: this.businessNameData.doc_num,
            ruc : this.businessNameData.doc_num
          };
          break;
        case 'DNI':
           objClientData = {
            id: this.businessNameData.id_client,
            companyName: this.businessNameData.name,
            direction: this.businessNameData.address,
            doc_num: this.businessNameData.doc_num,
            dni : this.businessNameData.doc_num,
        }
        break;
        case 'EXPORTACION':
           objClientData = {
           id: this.businessNameData.id_client,
            companyName: this.businessNameData.name,
            direction: this.businessNameData.address,
            doc_num: this.businessNameData.doc_num,
            any_document: this.businessNameData.doc_num
          
        }
        break;
      }
     
      this.cxcpaymentService.cxcRegister({
        id_client: this.businessNameData.id_client,
        client_address: this.businessNameData.address,
        client_doc_num: this.businessNameData.doc_num,
        client_doc_type: this.businessNameData.doc_type,
        client_email: this.businessNameData.email,
        money: this.billingData.money,
        tipo_de_cambio : this.billingData.tipo_de_cambio,
        clientData: objClientData,
        detail: this.billingData.detail,
        discounts: this.billingData.discounts,
        budgetHeader: this.budgetHeaderData,
        billData: this.billingData,
        det_account: this.detraction_account,
        tipo: this.billingData.tipo,
        discount_global :this.billingData.discount_global,
        nota_credito: this.billingData.nota_credito,
        nota_debito: this.billingData.nota_debito
      }
      ).subscribe((result: any) => {
        this.showPopup = false;
        this.bill_building = false;
        this.internalService.internalNotify({ pronosBill: {}, budgetHeader: {}, show: false })
        this.notifierService.systemNotify({
          title: 'Exito',
          message: 'Se ha realizado la factura correctamente.',
          duration: 4000,
          type: 'success'
        });
        this.routes.navigate(['/system/billing/list']);
      }, (error) => {
        this.bill_building = false;
        console.log(error);
        this.notifierService.systemNotify({
          title: 'Error',
          message: error.error.message,
          type: 'error',
          duration: 5000,
        });
      });
    }else{
      this.bill_building = false;
    }
  }

  createNote() {
    this.bill_building = true;
    console.log("notas")
    if (this.billingData.fechaVencimiento && this.billingData.condicionesPago) {
      this.notifierService.systemNotify({
        title: 'Espere',
        message: 'Generando Nota',
        type: 'info',
        duration: 20000
      });
      //this.billingService.getOneBilling(this.billingData.id_factura_emitida).subscribe((result)=>{
        //this.factura_id=result
        //console.log("factura",result)
      //})
      var objClientData;
      switch( this.businessNameData.doc_type){

       

        case 'RUC':
          objClientData = {
        
            id: this.businessNameData.id_client,
            companyName: this.businessNameData.name,
            direction: this.businessNameData.address,
            doc_num: this.businessNameData.doc_num,
            ruc : this.businessNameData.doc_num
          };
          break;
        case 'DNI':
           objClientData = {
            id: this.businessNameData.id_client,
            companyName: this.businessNameData.name,
            direction: this.businessNameData.address,
            doc_num: this.businessNameData.doc_num,
            dni : this.businessNameData.doc_num,
        }
        break;
        case 'EXPORTACION':
           objClientData = {
           id: this.businessNameData.id_client,
            companyName: this.businessNameData.name,
            direction: this.businessNameData.address,
            doc_num: this.businessNameData.doc_num,
            any_document: this.businessNameData.doc_num
          
        }
        break;
      }

      this.cxcpaymentService.cxcRegisterNote({
        id_client: this.businessNameData.id_client,
        client_address: this.businessNameData.address,
        client_doc_num: this.businessNameData.doc_num,
        client_doc_type: this.businessNameData.doc_type,
        client_email: this.businessNameData.email,
        money: this.billingData.money,
        clientData: objClientData,
        detail: this.billingData.detail,
        discounts: this.billingData.discounts,
        budgetHeader: this.budgetHeaderData,
        billData: this.billingData,
        det_account: this.detraction_account,
        tipo: this.billingData.tipo,
        nota_credito: this.billingData.nota_credito,
        nota_debito: this.billingData.nota_debito,
        id_factura_emitida: this.billingData.id_factura_emitida
      }
      ).subscribe((result: any) => {
        this.showPopup = false;
        this.bill_building = false;
        this.internalService.internalNotify({ pronosBill: {}, budgetHeader: {}, show: false })
        this.notifierService.systemNotify({
          title: 'Exito',
          message: 'Se ha realizado la nota correctamente.',
          duration: 4000,
          type: 'success'
        });
        this.routes.navigate(['/system/billing/list']);
      }, (error) => {
        this.bill_building = false;
        console.log(error);
        this.notifierService.systemNotify({
          title: 'Error',
          message: error.error.message,
          type: 'error',
          duration: 5000,
        });
      });
    }
  }

  closeModal() {
    this.showPopup = false;
    this.internalService.internalNotify({ pronosBill: {}, budgetHeader: {}, show: false })
  }

}
export interface IBusiness {
  id?: number;
  tenant?: string;
  name?: string;
  doc_num?: string;
  doc_type?: string;
  email?: string;
  id_client?: number;
  address?: string;
}



// WEBPACK FOOTER //
// ./src/app/system/billing/bill-specific/bill-specific.component.ts